import { Box, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

interface ContactRowProps {
    label: string;
    value: string;
    isEmail?: boolean;
    mb?: number;
    wrap?: boolean;
}

export const ContactRow = ({
    label,
    value,
    isEmail = false,
    mb = 0,
    wrap = false,
}: ContactRowProps) => {
    const textRef = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const element = textRef.current;
        if (element) {
            // Check if the content is truncated
            setIsTruncated(element.scrollWidth > element.clientWidth);
        }
    }, [value]);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: wrap ? 'flex-start' : 'center',
                justifyContent: 'flex-start',
                mb,
            }}
        >
            <Typography
                typography="openSans.subtitle2"
                fontWeight={400}
                color="grey.600"
                sx={{ minWidth: '80px', flexShrink: 0 }}
            >
                {label}
            </Typography>
            <Typography
                ref={textRef}
                typography="openSans.subtitle2"
                fontWeight={400}
                sx={{
                    overflow: 'hidden',
                    textOverflow: wrap ? 'unset' : 'ellipsis',
                    whiteSpace: wrap ? 'normal' : 'nowrap',
                    wordBreak: wrap ? 'break-word' : undefined,
                    flex: 1,
                    minWidth: 0,
                    ...(isEmail
                        ? {
                              color: 'primary.main',
                              textDecoration: 'none',
                              '&:hover': {
                                  textDecoration: 'underline',
                              },
                          }
                        : {}),
                }}
                component={isEmail ? 'a' : 'span'}
                href={isEmail ? `mailto:${value}` : undefined}
                title={isTruncated ? value : undefined}
            >
                {value || '-'}
            </Typography>
        </Box>
    );
};
